<div [ngStyle]="transformWhileDragging" class="flex flex-grow min-h-full w-full">
  @if (canRefresh) {
    <soft-pull-to-refresh-indicator
      [dragDistance]="dragDistance"
      >
    </soft-pull-to-refresh-indicator>
  }
  <div class="flex flex-grow min-h-full custom-width">
    <ng-content></ng-content>
  </div>
</div>
